import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';

import { AppMaterialModule } from 'src/app-client/layouts/material/app.material.module';
import { AppShareModule } from 'src/shared/app.module';
import { ProductDetailComponent } from './detail/product-detail.component';
import { ProductListComponent } from './list/product-list.component';
import { ProductListContactUsComponent } from './list/contact-us/product-list-contact-us.component';
import { ProductListHeroComponent } from './list/hero/product-list-hero.component';
import { ProductRoutingModule } from './product-routing.module';
import { PurchasedProductListComponent } from './purchased-product-list/purchased-product-list.component';
import { ShareModule } from 'src/app-client/_appCommon/share.module';

@NgModule({
  declarations: [
    ProductListComponent,
    ProductListHeroComponent,
    ProductDetailComponent,
    ProductListContactUsComponent,
    PurchasedProductListComponent,
  ],
  imports: [
    AppMaterialModule,
    AppShareModule,
    CommonModule,
    FormsModule,
    ProductRoutingModule,
    ReactiveFormsModule,
    ShareModule,
    SwiperModule,
  ],
  exports:
  [
    ProductListComponent,
    PurchasedProductListComponent,
  ]
})
export class ProductModule { }
